import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Compraste juguetes caros que terminaron debajo de la heladera y él nunca más tocó.', "Usaste sprays 'repelentes' que solo lograron que el living huela a químico y el gato se estrese más.", 'Pusiste rascadores bajitos que no le permiten estirar la columna, por eso prefiere la altura de tu sillón.', "Lo retás cuando rompe algo, pero para él, tus gritos son la única 'diversión' que tuvo en todo el día."];
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl md:text-4xl mb-4" data-id="element-18">
            Seguro ya intentaste de todo...
          </h2>
          <p className="text-xl text-warmBrown/70" data-id="element-19">
            Y nada funcionó a largo plazo.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-20">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-cream/50 transition-colors" data-id="element-21">
              <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-22" />
              <p className="text-lg text-warmBrown/90" data-id="element-23">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}